<template>
    <div id="manualInvoiceView">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Invoice Detail</div>
                    <div class="btn-groups text-right">
                        <button type="button" class="btn btn-primary" v-on:click="print()" >
                            <i class="fp-print"> </i> Print
                        </button>
                        <button type="button" class="btn btn-primary" v-on:click="downloadPdf()" >
                            <i class="fp-export"> </i> Download
                        </button>
                        <button type="button" class="btn btn-secondary" v-on:click="backBtn()" >
                            <i class="fp-back"> </i> Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content fuel-invoice-preview">
                        <section class="bg-white">
                            <div class="invoice-view-table" id="print_content">

                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';

    
    import {commonMixins} from '../../mixins/commonMixins';
    

    export default {
        name: "FuelTicketInvoiceView",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Customer Invoice Preview | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins],
        data: () => ({
            invoiceArr:[],
            loading:false,
            permissions:[],
            cantAccessPage:"",
            invoiceId : 0,
            path:"",
            invoice_number:'',
            invoice_date:'',
            due_date:'',
            customer:'',
            terms:'',
            po_no:'',
            invoice_type:'',
            sub_total:'',
            tax_amount:'',
            total:'',
            invoiceItemsArr:[],
            cust_code:'',
            cust_name:'',

        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'view_invoice') {
                        self.cantAccessPage = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },
        mounted: function() {
            var self = this;
            self.invoiceId = this.$route.params.id;
            self.getPermissions();
            self.previewInvoice();
            self.path = process.env.API +  "/images/logo.png";
        },
        methods : {
            backBtn(){
                var self = this;
                self.$router.push("/invoice/list");
            },
            downloadPdf() {
                var self = this;
                self.loading = true ;
                $.ajax({
                    url: process.env.ROOT_API + "/invoice/pdf",
                    type: "POST",
                    data: {
                        invoice_id:self.invoiceId,
                        invoice_type:"FB",
                        invoice_origin:"system"
                    },
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false ;
                        if (data.status == 'success'){
                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = data.content;
                            link.download = '';
                            link.target = "_blank";
                            link.click();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'permit-invoice-pdf');
                    }
                });

            },
            previewInvoice() {
                var self = this;
                self.loading = true;
                $.ajax({
                    // url: process.env.ROOT_API + "/invoice-permit/view",
                    url: process.env.ROOT_API + "/fuel-ticket-invoice/preview",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data:{invoice_id:self.invoiceId,from:'preview'},
                    dataType: "json",
                    success: function(data) {
                        self.loading = false;
                        setTimeout(function(){
                            $("#print_content").html("");
                            $("#print_content").html(data.view);
                        },500);

                        //var content = data;
                        //$( "div.second" ).replaceWith

                        //
                    },
                    error: function(jqXHR, exception) {

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'fuel-ticket-invoice-preview');
                    }
                });
            },
            print() {
                var self = this;
                self.loading = true;
                var content = document.getElementById('print_content').innerHTML;
                console.log(content);
                var link = window.open(content, '_blank');
                link.document.write(content);
                link.document.close();
                self.loading = false;
                link.print();
                link.close();

            }

        }
    }
</script>




// WEBPACK FOOTER //
// src/components/invoice/FuelTicketInvoiceView.vue